import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import scrollToTop from '../helpers/scrollToTop';

function ReservationConflict() {
  useEffect(() => {
    scrollToTop();
  }, []);

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 50,
    },
    in: {
      opacity: 1,
      y: 0,
    },
    out: {
      opacity: 0,
      y: -50,
    },
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5,
  };

  return (
    <motion.div
      className="min-h-screen bg-neutral-100"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-8 border border-red-800">
          <div className="mb-8">
            <div className="text-8xl mb-6">⚠️</div>
            <h1 className="text-4xl md:text-5xl font-bold text-red-800 mb-4">
              Съжаляваме!
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-red-700 mb-6">
              Резервацията е неуспешна
            </h2>
          </div>

          <div className="mb-8">
            <p className="text-xl md:text-2xl text-neutral-700 mb-4">
              Бяхте малко по-бавни с потвърждението.
            </p>
            <p className="text-lg md:text-xl text-neutral-600 mb-6">
              Друг потребител вече резервира този час. Моля, изберете друг свободен час.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/reservations"
              className="bg-red-800 text-white px-8 py-4 rounded-lg text-xl font-semibold shadow-lg transform transition duration-300 hover:bg-red-700 hover:scale-105 hover:shadow-xl active:scale-95 active:bg-red-900 focus:outline-none focus:ring-4 focus:ring-red-500 w-full sm:w-auto"
            >
              Избери друг час
            </Link>
            <Link
              to="/"
              className="bg-neutral-600 text-white px-8 py-4 rounded-lg text-xl font-semibold shadow-lg transform transition duration-300 hover:bg-neutral-500 hover:scale-105 hover:shadow-xl active:scale-95 active:bg-neutral-700 focus:outline-none focus:ring-4 focus:ring-neutral-400 w-full sm:w-auto"
            >
              Обратно към началото
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default ReservationConflict;
